<template>
  <div>
    <div class="modal-header">
      <h2>Dodaj trošak</h2>
    </div>
    <div class="body">
      <div class="input-wrapper">
        <div class="name--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--name"
            placeholder=" "
            v-model="expense.name"
          />
          <span class="input-span input-span--name">Naziv</span>
        </div>
        <div class="amount--mod relative">
          <input
            type="text"
            class="form-control form-control-lg input--amount"
            placeholder=" "
            v-model.lazy="expense.price"
            v-money="{}"
          />
          <span class="input-span input-span--amount">Iznos</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>
      <div class="buttons">
        <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
        <button type="submit" class="btn btn-primary btn--mod" :disabled="loading" @click="save">
          <p v-if="!loading">Sačuvaj</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { financesInstance } from '@/axios/axios.js';
import { mapMutations, mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      expense: {
        name: '',
        price: ''
      },
      loading: false
    };
  },
  computed: {
    ...mapState('finances', ['expenses'])
  },
  destroyed() {
    document.removeEventListener('keydown', this.processKeyboardEvent);
  },
  created() {
    document.addEventListener('keydown', this.processKeyboardEvent);
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('finances', ['getTableData', 'getAccountDetails']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    save() {
      this.loading = true;
      this.errorOccurred = false;
      if (this.doesErrorExist()) {
        // this.errorMessage = 'Neispravan unos podataka';
        this.errorOccurred = true;
        this.loading = false;
        return;
      }
      let price = parseFloat(
        parseFloat(this.expense.price.replace(/,/g, '')).toFixed(2)
      );

      if (price <= 0) {
        this.errorMessage = 'Iznos ne može biti manji ili jednak nuli';
        this.errorOccurred = true;
        this.loading = false;
        return;
      }

      financesInstance
        .post(
          `communities/${
            this.$store.getters.getActiveCommunity.community_id
          }/expenses`,
          {
            name: this.expense.name,
            price: price
          }
        )
        .then(async () => {
          await this.getTableData({
            communityId: this.$store.getters.getActiveCommunity.id,
            tableName: 'expenses'
          });
          if (this.$router.history.current.name !== 'communityFinancesHome') {
            this.setTableData(this.expenses.data);
          } else {
            this.getAccountDetails();
          }
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.errorOccurred = true;
          this.loading = false;
          this.showFailModal();
        });
    },
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      } else if (e.key === 'Enter') {
        this.save();
      }
    },
    doesErrorExist() {
      return this.areFieldsEmpty() || this.numberFieldContainsLetters();
    },
    areFieldsEmpty() {
      if (this.expense.name === '' || this.expense.price === '') {
        this.errorMessage = 'Polje naziv ne sme biti prazno.';
        return true;
      }
      if (this.expense.name.length > 80) {
        this.errorMessage = 'Polje naziv ne može imati preko 80 karaktera.';
        return true;
      }
      return false;
    },
    numberFieldContainsLetters() {
      if (this.expense.price.match(/[a-zA-Z]/g) == true) {
        this.errorMessage = 'Polje za iznos ne sve sadržati slova';
        return true;
      }
      let price = parseFloat(
        parseFloat(this.expense.price.replace(/,/g, '')).toFixed(2)
      );
      if (price > 100000000) {
        this.errorMessage = 'Iznos ne sme biti veći od 100,000,000';
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  padding: 2rem 0;
}

hr {
  margin-top: 0;
}

.input-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  position: relative;
}

.name--mod {
  width: 60%;
}

.input-span {
  position: absolute;
  font-size: 1.5rem;
  color: rgb(95, 95, 95);
  top: 0.5rem;
  pointer-events: none;
  transition: 0.2s all;
}

.input-span--name {
  left: 1rem;
}

.input-span--amount {
  left: 1rem;
}

input[type='number'] {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input {
  margin-right: 15px;
}

.input--name:focus ~ .input-span--name,
.input--name:not(:placeholder-shown) ~ .input-span--name {
  transform: scale(0.75) translateY(-50px) translateX(-30px);
  // opacity: 0;
}

.input--amount:focus ~ .input-span--amount,
.input--amount:not(:placeholder-shown) ~ .input-span--amount {
  transform: scale(0.75) translateY(-50px) translateX(-30px);
}

.relative {
  position: relative;
}

.amount--mod {
  width: 30%;
}

.error {
  color: red;
  float: left;
  margin: 0 auto;
  margin-left: 1rem;
  display: flex;
  align-items: center;
}

.footer {
  width: 100%;
  .buttons {
    float: right;
    height: 38px;

    .btn--mod {
      height: 35px;
      margin-left: 5px;
      align-self: center;
    }

    button {
      min-width: 75px;
    }

    button:disabled {
      background-color: var(--primary-color-lighten);
      cursor: not-allowed;
    }
  }
}

.buttons {
  float: right;
}
</style>
